/** Authoring states that keep the viewer polling (spec §5; pending/tables_ready are the
 *  transient pre-write states — without them the spectator misses tables landing and the
 *  first section). complete/tables_failed never poll. */
export const LIVE_STATUSES = new Set(['pending', 'tables_ready', 'writing'])
